module.exports = __webpack_public_path__ + "static/img/btn_4.271ef80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_4.png
// module id = 4iNx
// module chunks = 1